import { useState } from "react";
import { useTranslation } from "react-i18next";
import { browserBuild, useReleases } from "@/api/releases";
import { updateTarget } from "@/lib/releaseState";
import { Button } from "@/components/ui/Button";
import { Modal } from "@/components/ui/Modal";
export function UpdateNotice() {
  const { t } = useTranslation();
  const { data } = useReleases();
  const target = updateTarget(browserBuild, data?.current);
  const [dismissed, setDismissed] = useState<string | null>(null);
  const [confirm, setConfirm] = useState(false);
  if (!target || dismissed === target.id) return null;
  return (
    <>
      <div
        role="status"
        className="flex shrink-0 flex-wrap items-center gap-2 border-b border-line bg-info-tint px-4 py-2 text-xs text-ink"
      >
        <span className="mr-auto">
          {t("releases.updateAvailable", { version: target.version })}
        </span>
        <Button size="sm" variant="secondary" onClick={() => setConfirm(true)}>
          {t("releases.reload")}
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => setDismissed(target.id)}
        >
          {t("releases.later")}
        </Button>
      </div>
      {confirm && (
        <Modal
          title={t("releases.reloadTitle")}
          closeLabel={t("common.cancel")}
          onClose={() => setConfirm(false)}
          className="max-w-md"
        >
          <div className="space-y-4 p-4">
            <p className="text-sm text-ink-soft">{t("releases.saveFirst")}</p>
            <div className="flex flex-wrap gap-2">
              <Button variant="secondary" onClick={() => setConfirm(false)}>
                {t("common.cancel")}
              </Button>
              <Button onClick={() => window.location.reload()}>
                {t("releases.savedReload")}
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
